module.exports = __webpack_public_path__ + "img/0Q3A5767_L_BlackMatted_MockedUp.745cda50.jpg";